import noop from 'lodash/noop'
import PropTypes from 'prop-types'
import React from 'react'

const PrevArrow = ({ onClick }) => {
  return (
    <button onClick={onClick} className="btn btn-light btn-sm" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">       
      <i className="fa fa-angle-left"></i>
    </button>
  )
}

PrevArrow.propTypes = {
  onClick: PropTypes.func
}

PrevArrow.defaulProps = {
  onClick: noop
}

export default PrevArrow
